module.exports = __webpack_public_path__ + "img/193.52a34ba0.jpg";